/// <reference path="../../../typings/browser.d.ts" />

namespace Application.Controllers {
    'use strict';
    
    export interface IComparatorScope extends ng.IScope {
        test: String;
        modalClose: () => void;
        modalSave: () => void;
    }
    
    /**
     * DashboardController class
     */
    export class ModalController {
        public static ID: string = "#id-modal";
        public static $name: string = "modalController";
        public static $inject: string[] = ['$scope', 'close', 'test'];

        private $scope: IComparatorScope;
        private close: (parameters: ngModal.ICloseParameters) => void;

        /**
         * Constructor
         */
        constructor($scope: IComparatorScope, close: (parameters: ngModal.ICloseParameters) => void, test: String) {
            this.$scope = $scope;
            this.$scope.test = test;
            this.close = close;
            
            this.$scope.modalClose = (): void => {
                this.close(undefined);
            };
            
            this.$scope.modalSave = (): void => {
                this.close(this.$scope.test);
            };
        }
    }
}
